import { useEffect } from "preact/hooks";

/**
 * Sprint-007 D4 — UX §5's "Initial focus, full-page screens" a11y rule:
 * on mount, move focus to the screen's own `<h1>` (given `tabindex="-1"`
 * in the consuming component) so a screen-reader user gets an
 * announcement of the new screen on navigation. Deliberately does NOT
 * auto-focus the first input — that pattern is correct only for in-page
 * modals/sheets, where `useModalA11y`'s `initialFocusRef` already handles
 * it. Shared by every full-page auth screen this sprint (`LoginView`,
 * `CredentialSetupView`) so the same rule is applied identically rather
 * than three slightly-different `useEffect`s.
 */
export function useFocusHeadingOnMount(ref: { current: HTMLElement | null }): void {
  useEffect(() => {
    ref.current?.focus();
    // Intentionally empty deps — this is a mount-only effect; the screen
    // itself unmounts/remounts on a real navigation change (app.tsx swaps
    // components rather than re-rendering this one in place).
  }, []);
}
